<app-confirmation-modal>
  <ng-container subHeader><strong>Are you sure you want to deny credentials?</strong></ng-container>
  <ng-container content
    >Denying credentials will remove the participant from the session.</ng-container
  >

  <ng-container actionButton>
    <app-button type="secondary" (buttonClick)="this.backToIdVerificationView()"> Go Back </app-button>
    <app-button type="warning" (buttonClick)="this.confirmRejoinDenial()"> Deny Credentials </app-button>
  </ng-container>
</app-confirmation-modal>
